export default __webpack_public_path__ + "static/media/phone.c2e3b61a.svg";